import {
  closestCorners,
  DndContext as KitDndContext,
  DndContextProps,
  DragEndEvent as KitDragEndEvent,
  DragOverEvent as KitDragOverEvent,
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

export const DndContext = (props: DndContextProps) => {
  const sensors = useSensors(
    useSensor(MouseSensor),
    useSensor(TouchSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    })
  );

  return <KitDndContext sensors={sensors} collisionDetection={closestCorners} {...props} />;
};

export * from './draggable';
export * from './droppable';
export type DragOverEvent = KitDragOverEvent;
export type DragEndEvent = KitDragEndEvent;
